<template>
  <div class="contents renraku">
      <h2>会社連絡登録</h2>

      <div class="container">
          <template v-if="isLoading">
              <template v-if="!isError">
                  <div class="loading-container">
                      <i class="fa-solid fa-spinner fa-spin-pulse"></i><br />
                      <p>データ読み込み中...</p>
                  </div>
              </template>
          </template>
          <template v-else>
              <div class="baseinfo">

              </div><!-- /baseinfo -->

              <div class="maininfo">
                <template v-if="form">

                  <div>
                    <p>会社連絡の送付先を選択して下さい</p>
                    <input-radio :options="OptionConst.KAISYA_RENRAKU_TARGET_TYPE_OPTION" v-model="form.target_type"></input-radio>

                    <!-- 全社員選択時 -->
                    <template v-if="form.target_type === OptionConst.KAISYA_RENRAKU_TARGET_TYPE.TO_ALL && option !== undefined">
                      <p>所属を選択して下さい</p>
                      <select-box :options="option.syozoku" :hasBlank="false" v-model="form.mst_syozoku_id"></select-box>
                    </template>

                    <!-- 部課選択時 -->
                    <template v-if="form.target_type === OptionConst.KAISYA_RENRAKU_TARGET_TYPE.TO_BUKA && option !== undefined">
                      <p>部課を選択して下さい</p>
                      <select-box :options="option.buka" :hasBlank="false" v-model="form.target_buka_id"></select-box>
                    </template>

                    <!-- 個人選択時 -->
                    <template v-if="form.target_type === OptionConst.KAISYA_RENRAKU_TARGET_TYPE.TO_KOJIN">
                      <div>
                        <div class="facility-search">
                          <div class="search-container">
                            <div class="item-container">
                              <label>
                                <!-- <b class="optional">検索条件：仮：検討中。現在は全ユーザーを取得</b> -->
                                <!-- <input-text v-model="searchCondition" type="text"></input-text> -->
                              </label>
                            </div>
                            <div class="item-container">
                              <label>
                                <p class="required">ユーザーを検索します。</p>
                              </label>
                            </div>

                            <div class="btn-container">
                              <button type="button" class="btn primary" @click="search"><i
                                  class="fa-solid fa-magnifying-glass"></i>検索</button>
                            </div>
                          </div>

                          <div class="search-result" v-if="searchedUserList.length">
                            <scroll-table max-height="calc(70vh - 340px)">
                              <table>
                                <thead>
                                  <tr>
                                    <th>&nbsp;</th>
                                    <th>社員番号</th>
                                    <th>ユーザー名</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(row, index) in searchedUserList" :key="index">
                                    <td class="delete"><input-checkbox :options="OptionConst.NO_LABEL" v-model="row.is_select"
                                        :disabled="row.active"></input-checkbox></td>
                                    <td>{{ row.staff_code }}</td>
                                    <td>{{ row.staff_name }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </scroll-table>
                          </div>
                        </div>
                      </div>
                    </template>

                  </div>

                  <div class="item">
                    <p class="required">連絡事項</p>
                    <input-textarea v-model="form.title"></input-textarea>
                  </div>

                  <div class="item">
                    <p class="required">掲載開始日</p>
                    <date-picker v-model="form.tmp_start_datetime" readonly="readonly"></date-picker>
                    <p class="required">掲載開始時刻</p>
                    <vue-timepicker v-model="form.start_time" readonly="readonly"></vue-timepicker>
                    <p>～</p>
                    <p class="required">掲載終了日</p>
                    <date-picker v-model="form.tmp_end_datetime" readonly="readonly"></date-picker>
                    <p class="required">掲載終了時刻</p>
                    <vue-timepicker v-model="form.end_time" readonly="readonly"></vue-timepicker>
                  </div>

                  <div class="btn-container">

                    <p class="btn-temporary-save">
                      <button type="button" @click="createNewRenraku" :disabled="isLoading || isCreating">
                        <template v-if="isCreating">
                          <i class="fa-solid fa-spinner fa-spin-pulse"></i>会社連絡　作成中…
                        </template>
                        <template v-else>
                          <i class="fa-solid fa-floppy-disk"></i>会社連絡を作成
                        </template>
                      </button>
                    </p>

                  </div>
                </template>

              </div><!-- /maininfo -->
          </template>
      </div>


  </div>
</template>

<script lang="ts">

import { defineComponent, computed } from 'vue'
import { useInit } from '@/composable/renraku/create/init';
import { useCreate } from '@/composable/renraku/create/create';
import { useSearch } from '@/composable/renraku/create/search';
import { RouterConst } from '@/const/Router';
import OptionConst from "@/const/Option";
import { DialogService } from '@/service/DialogService';
import { SweetAlertResult } from 'sweetalert2';
import { useAuthStore } from '@/store/auth';

import VueTimepicker from 'vue3-timepicker/src/VueTimepicker.vue'
import 'vue3-timepicker/dist/VueTimepicker.css';
import { PermissionConst } from '@/const/Permission';

export default defineComponent({
  setup(context) {

    // 初期化
    const { isLoading, isError, form, option } = useInit();

    // 会社連絡登録
    const { isCreating, createRenraku } = useCreate();

    // 会社連絡宛先ユーザーを取得
    const { addUserParam, searchedUserList, searchRenrakuUser } = useSearch();

    const authStore = useAuthStore();

    const syozokuId = computed(() => {
      return authStore.user?.mst_syozoku_id
    })

    // ユーザーを検索します
    const search = () => {
      searchRenrakuUser();
    };

    // 会社連絡を作成する
    const createNewRenraku = (() => {
      DialogService.question({
        text: '会社連絡を作成しますか？',
        showCancelButton: true,
        confirmButtonText: '作成します',
        cancelButtonText: 'キャンセル',
      }).then((result: SweetAlertResult) => {
        if (result.isConfirmed) {

          if (!form.value) {
            DialogService.error({
              text: '登録データがありません。'
            }, true);
            return;
          }

          // 宛先が全員の場合
          if (form.value.target_type === OptionConst.KAISYA_RENRAKU_TARGET_TYPE.TO_ALL)
          {
            // 宛先部課情報を削除
            form.value.target_buka_id = undefined;
            // 宛先ユーザー情報を削除
            form.value.target_user_ids = undefined;
          }

          // 宛先が部課の場合
          if (form.value.target_type === OptionConst.KAISYA_RENRAKU_TARGET_TYPE.TO_BUKA)
          {
            // 宛先ユーザー情報を削除
            form.value.target_user_ids = undefined;
          }

          // 宛先がユーザーの場合
          if (form.value.target_type === OptionConst.KAISYA_RENRAKU_TARGET_TYPE.TO_KOJIN)
          {
            // 宛先部課情報を削除
            form.value.target_buka_id = undefined;

            // 選択されているユーザーを取得
            let selectItems = searchedUserList.value.filter((v: any) => v.is_select);

            const all = addUserParam.value.concat(selectItems);
            // 既に追加されているもの(重複)は排除する
            form.value.target_user_ids = [...new Map(all.map((o: any) => [o.user_id, o])).values()];
          }

          createRenraku(form.value);
        }
      })
    });

    return {
      isLoading,
      isError,
      form,
      RouterConst,
      createRenraku,
      isCreating,
      OptionConst,
      createNewRenraku,
      option,
      search,
      addUserParam,
      searchedUserList,
      searchRenrakuUser,
      authStore,
      PermissionConst,
      syozokuId,
    }
  },
  components: {
    'vue-timepicker': VueTimepicker,
  }
})
</script>
